import "../collections/slots.js";
import "./slot.js";
import "./slot_stack.js";
import "./base.js";

// This will be used to contain the slot information

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.AddressGroup = class AddressGroup extends (
  AppointmentBooking.SlotSuggester.Models.Base
) {
  static {
    this.prototype.relations = [
      {
        // Slots suggested for the currently selected date
        type: Backbone.HasMany,
        key: "slots",
        relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
        collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
      },
    ];
  }

  static createAll(slots, options = {}) {
    const map = {};
    slots.forEach((slot) => {
      let addressGroup;
      const departmentId = slot.get("departmentId");

      if (!(addressGroup = map[departmentId])) {
        addressGroup = new this({
          departmentId,
          date: slot.startMoment,
          limit: options.limit,
          desiredStartTime: options.desiredStartTime,
          desiredDepartmentId: options.desiredDepartmentId,
          selectedProvider: options.selectedProvider,
          selectedSlotId: options.selectedSlotId,
        });
        map[departmentId] = addressGroup;
      }

      // Enforce that all slots in the group have the same start date, since we assume that in the UI
      if (addressGroup.get("date").isSame(slot.startMoment, "day")) {
        return addressGroup.get("slots").add(slot);
      }
    });

    const groups = Object.values(map);

    return new AppointmentBooking.SlotSuggester.Collections.Base(groups);
  }

  constructor() {
    super(...arguments);
    this.toJSON = this.toJSON.bind(this);
    this.buildSlotStacks = this.buildSlotStacks.bind(this);
  }

  defaults() {
    return {
      departmentId: null,
      slots: [],
      date: null,

      limit: null,
      desiredStartTime: null,
      desiredDepartmentId: null,
      selectedProvider: null,
      selectedSlotId: null,
    };
  }

  // RENDERING

  toJSON(options) {
    return {
      departmentId: this.get("departmentId"),
      date: this.get("date"),
      isDesiredDepartmentId: this.get("departmentId") === this.get("desiredDepartmentId"),
      address: this.get("slots").first().get("address"),
      slotStacks: this.buildSlotStacks().toJSON(),
    };
  }

  buildSlotStacks() {
    let sameTimeSlotStack;
    let selectedSlotStack;
    const slots = this.get("slots");
    const limit = this.get("limit");
    const desiredStartTime = this.get("desiredStartTime");
    const selectedProvider = this.get("selectedProvider");
    const selectedSlotId = this.get("selectedSlotId");

    const stacks = AppointmentBooking.SlotSuggester.Models.SlotStack.createAll(slots, { limit, desiredStartTime });

    // Flag the stack as being for the same time as the desired slot if it is
    if (desiredStartTime && (sameTimeSlotStack = stacks.findWhere({ startTime: desiredStartTime }))) {
      sameTimeSlotStack.set({ desiredTimeSlot: true });
    }

    // Modify the stack containing the selected slot
    if (selectedSlotId && (selectedSlotStack = stacks.find((stack) => stack.contains({ id: selectedSlotId })))) {
      selectedSlotStack.set({ containsSelectedSlot: true, text: selectedProvider.get("name") });
    }

    return stacks;
  }
};
